// src/redux/actions/cityActions.js
import {
    FETCH_JOB_TITLE_REQUEST,
    FETCH_JOB_TITLE_SUCCESS,
    FETCH_JOB_TITLE_FAILURE,
    SET_SELECTED_JOB_TITLE
} from '../types';
import axios from '../../API/axios';

export const fetchJobTitleData = (searchTerm = '') => async (dispatch) => {
    dispatch({ type: FETCH_JOB_TITLE_REQUEST });

    try {
        const response = await axios.get(`/Job/GetJobTitleDdl?Search=${searchTerm}`);
        let jobTitleList = response.data.responseData.map((val) => {
            return {
                value: val,
                label: val,
            }
        })
        dispatch({
            type: FETCH_JOB_TITLE_SUCCESS,
            payload: jobTitleList,
        });
    } catch (error) {
        dispatch({
            type: FETCH_JOB_TITLE_FAILURE,
            payload: error.message,
        });
    }
};

export const selectJobTitle = (jobTitleId) => ({
    type: SET_SELECTED_JOB_TITLE,
    payload: jobTitleId,
});
